/**
 * Torta CSS (conic-gradient) — sin librería.
 * @param {{ rows: Array<{ label:string, value:number|null }>, emptyText?: string, valueSuffix?: string }} props
 */
import { formatAnalyticsNumber } from '../utils/format-number.js';

const PIE_COLORS = [
  '#1d4f91',
  '#c9a84c',
  '#1f7a4d',
  '#5b6b7c',
  '#b78100',
  '#3d6fad',
  '#8b7355',
  '#2a9d8f',
  '#b42318',
  '#6c63ff'
];

export default function SimplePieChart({
  rows,
  emptyText = 'Sin datos para graficar.',
  valueSuffix = ''
}) {
  const list = (Array.isArray(rows) ? rows : [])
    .filter((r) => r && r.label)
    .map((r) => ({
      label: String(r.label),
      value: Number(r.value)
    }))
    .filter((r) => Number.isFinite(r.value) && r.value > 0);

  if (!list.length) {
    return <p className="analytics-empty">{emptyText}</p>;
  }

  const total = list.reduce((s, r) => s + r.value, 0) || 1;
  let cursor = 0;
  const slices = list.map((r, i) => {
    const pct = (r.value / total) * 100;
    const start = cursor;
    cursor += pct;
    return {
      ...r,
      color: PIE_COLORS[i % PIE_COLORS.length],
      pct: Math.round(pct * 10) / 10,
      start,
      end: cursor
    };
  });

  const gradient = slices
    .map((s) => s.color + ' ' + s.start + '% ' + s.end + '%')
    .join(', ');

  return (
    <div className="analytics-pie" role="img" aria-label="Gráfico de torta">
      <div className="analytics-pie-visual">
        <div
          className="analytics-pie-disc"
          style={{ background: 'conic-gradient(' + gradient + ')' }}
        />
        <div className="analytics-pie-hole">
          <span className="analytics-pie-total num">
            {formatAnalyticsNumber(Math.round(total * 100) / 100)}
            {valueSuffix}
          </span>
          <span className="analytics-pie-total-label">Total</span>
        </div>
      </div>
      <ul className="analytics-pie-legend">
        {slices.map((s) => (
          <li key={s.label} className="analytics-pie-legend-item">
            <span className="analytics-pie-swatch" style={{ background: s.color }} />
            <span className="analytics-pie-legend-label" title={s.label}>
              {s.label}
            </span>
            <span className="analytics-pie-legend-value num">
              {formatAnalyticsNumber(s.value)}
              {valueSuffix}
            </span>
            <span className="analytics-pie-legend-pct">
              {formatAnalyticsNumber(s.pct)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
